import Banner from './Banner'
import DetailsBlock from './DetailsBlock'
import PlacesContainer from './PlacesContainer'
import Footer from './Footer'

function Homepage() {
    return (
      <div className="homepage">
        <Banner />
        <DetailsBlock
          title="Stories of Adventure"
          image="https://picsum.photos/id/1005/500/500"
        />
        <PlacesContainer/>
        <DetailsBlock
          title="Popular Adventures"
          image="https://picsum.photos/id/1015/500/500"
        />
        <Footer />
      </div>
    );
}


export default Homepage